import React from 'react';
import { motion } from 'framer-motion';

const photos = [
    // Original Placeholders
    { src: require('../pictures/joshwithwine.jpg'), alt: 'The Experience' },
    { src: require('../pictures/welcomezeronimo.jpg'), alt: 'Welcome Zeronimo' },
    { src: require('../pictures/patrickandkatja.jpg'), alt: 'Our Partners' },
    { src: require('../pictures/zeronimo-looking-up-optimized.jpg'), alt: 'Aim High' },

    // New Lifestyle & Winery Photos
    { src: require('../pictures/patrick-cellar.jpg'), alt: 'The Cellar' },
    { src: require('../pictures/red-wine-glass.jpg'), alt: 'Premium Red' },
    { src: require('../pictures/winery-building.jpg'), alt: 'The Winery' },
    { src: require('../pictures/sparkling-select-bottle.png'), alt: 'Sparkling Select' },
    { src: require('../pictures/zeronimo-lifestyle-1.jpg'), alt: 'Lifestyle' },
    { src: require('../pictures/zeronimo-lifestyle-2.jpg'), alt: 'Moments' },
    { src: require('../pictures/zeronimo-lifestyle-3.jpg'), alt: 'Cheers' },
    { src: require('../pictures/zeronimo-lifestyle-4.jpg'), alt: 'Craft' },
    { src: require('../pictures/zeronimo-lifestyle-5.jpg'), alt: 'Enjoy' },
];

export default function PhotoCarousel() {
    return (
        <div className="bg-black py-12 md:py-20 border-t border-gray-900 overflow-hidden relative">

            {/* Search/Apple-style Header */}
            <div className="max-w-7xl mx-auto px-6 mb-12 text-center">
                <h2 className="text-3xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-b from-white to-white/60 tracking-tight mb-4">
                    The Zeronimo Lifestyle
                </h2>
                <p className="text-gray-400 text-lg didact-gothic-regular max-w-2xl mx-auto">
                    Experience the world's finest non-alcoholic wine moments.
                </p>
            </div>

            {/* Gradient Fade Masks */}
            <div className="absolute left-0 top-0 bottom-0 w-24 md:w-48 z-10 bg-gradient-to-r from-black to-transparent pointer-events-none" />
            <div className="absolute right-0 top-0 bottom-0 w-24 md:w-48 z-10 bg-gradient-to-l from-black to-transparent pointer-events-none" />

            {/* Carousel Track */}
            <div className="flex">
                <motion.div
                    className="flex gap-6 md:gap-10 px-6"
                    animate={{
                        x: ["0%", "-50%"],
                    }}
                    transition={{
                        x: {
                            repeat: Infinity,
                            repeatType: "loop",
                            duration: 40,
                            ease: "linear",
                        },
                    }}
                >
                    {/* Double the array to create seamless loop effect */}
                    {[...photos, ...photos].map((photo, index) => (
                        <div
                            key={index}
                            className="relative w-[280px] md:w-[400px] flex-shrink-0 aspect-[4/5] rounded-2xl overflow-hidden group select-none"
                        >
                            <div className="absolute inset-0 bg-blue-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10 mix-blend-overlay" />

                            <img
                                src={photo.src}
                                alt={photo.alt}
                                className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110 opacity-100"
                                draggable="false"
                                loading="lazy"
                                decoding="async"
                            />

                            {/* Internal Frame/Border */}
                            {/* Removed the internal frame border as per instruction */}

                            <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-20">
                                <p className="text-white text-sm font-medium tracking-widest uppercase">{photo.alt}</p>
                            </div>
                        </div>
                    ))}
                </motion.div>
            </div>
        </div>
    );
}
